// Guard against double execution.
//
// layout/theme.liquid included this file twice — once in <head> and once at the
// end of <body>. Both copies ran, so every keystroke in #Search-In-Modal fired
// TWO Storefront API queries. The duplicate <script> tag has been removed from
// theme.liquid; this guard stays so a future re-inclusion cannot resurrect the
// double-binding.
if (window.__bsnIsbnPredictiveLoaded) {
  console.debug("isbn-predictive.js already initialised — skipping duplicate load");
} else {
  window.__bsnIsbnPredictiveLoaded = true;

  document.addEventListener("DOMContentLoaded", () => {
    const input = document.querySelector("#Search-In-Modal");
    const box = document.querySelector("#predictive-container");

    if (!input || !box) return;

    input.addEventListener("input", async (e) => {
      const query = e.target.value.trim();
      if (query.length < 3) {
        box.style.display = "none";
        return;
      }

      const gqlQuery = `
        {
          products(first: 10, query: "${query}") {
            edges {
              node {
                title
                handle
                featuredImage { url }
              }
            }
          }
        }
      `;

      try {
        const response = await fetch("/api/2024-01/graphql.json", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Shopify-Storefront-Access-Token": window.storefrontAccessToken,
          },
          body: JSON.stringify({ query: gqlQuery }),
        });

        const result = await response.json();

        const products = result?.data?.products?.edges || [];

        if (products.length === 0) {
          box.style.display = "none";
          return;
        }

        let html = "";
        products.forEach(({ node }) => {
          // alt is set from the title — an injected image with alt="" was audit item #7
          const safeTitle = (node.title || "").replace(/"/g, "&quot;");
          html += `
            <div class="predictive-item" onclick="window.location='/products/${node.handle}'">
              <img src="${node.featuredImage?.url || ''}" alt="${safeTitle} — book cover" loading="lazy" />
              <div>${node.title}</div>
            </div>
          `;
        });

        box.innerHTML = html;
        box.style.display = "block";

      } catch (err) {
        console.error("GQL Error", err);
      }
    });
  });
}
